// Whether the screen under the shell may offer a write (#702).
//
// A platform admin who enters a customer's context with no membership reads it as a
// viewer: the server refuses every write it would make there (`routes/auth.py`,
// `PLATFORM_VIEWER_WRITES`). The shell provides this once, from the session, so a
// screen that draws a write control asks one question rather than re-deriving it —
// and the server stays the enforcement: a control shown here by mistake is refused.

import { createContext, useContext } from "react";

export const ReadOnlyContext = createContext(false);

/** True when the screen must draw no write control: a platform admin's read-only view. */
export const useReadOnly = (): boolean => useContext(ReadOnlyContext);
